var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDecoration1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.097 0h13.142l12.607 15.156L84.24 30H71.097l12.607-14.754L71.097 0z",
    fill: "#08275C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0h13.142L72.75 15.156 60.142 30H47l12.608-14.754L47 0z",
    fill: "#08275C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.522 0h13.143l12.607 15.156L36.665 30H23.522L36.13 15.246 23.522 0z",
    fill: "#08275C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.142l12.652 15.156L13.142 30H0l12.608-14.754L0 0z",
    fill: "#08275C"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAwIDMwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNzEuMDk2NiAtMS4xMjU1NmUtMDZMODQuMjM4OCAtNS41MTA5N2UtMDdMOTYuODQ2NCAxNS4xNTY1TDg0LjIzODggMzBMNzEuMDk2NiAzMEw4My43MDQyIDE1LjI0NTlMNzEuMDk2NiAtMS4xMjU1NmUtMDZaIiBmaWxsPSIjMDgyNzVDIi8+CjxwYXRoIGQ9Ik00Ny4wMDAyIC0xLjEyNTU2ZS0wNkw2MC4xNDI0IC01LjUxMDk3ZS0wN0w3Mi43NSAxNS4xNTY1TDYwLjE0MjQgMzBMNDcuMDAwMiAzMEw1OS42MDc4IDE1LjI0NTlMNDcuMDAwMiAtMS4xMjU1NmUtMDZaIiBmaWxsPSIjMDgyNzVDIi8+CjxwYXRoIGQ9Ik0yMy41MjI0IC0xLjEyNTU2ZS0wNkwzNi42NjQ2IC01LjUxMDk3ZS0wN0w0OS4yNzIyIDE1LjE1NjVMMzYuNjY0NiAzMEwyMy41MjI0IDMwTDM2LjEzIDE1LjI0NTlMMjMuNTIyNCAtMS4xMjU1NmUtMDZaIiBmaWxsPSIjMDgyNzVDIi8+CjxwYXRoIGQ9Ik0tMy4wNTE3NmUtMDUgLTEuMTI3NTFlLTA2TDEzLjE0MjIgLTUuNTMwNDRlLTA3TDI1Ljc5NDQgMTUuMTU2NUwxMy4xNDIyIDMwTC0zLjE4Mjg5ZS0wNSAzMEwxMi42MDc2IDE1LjI0NTlMLTMuMDUxNzZlLTA1IC0xLjEyNzUxZS0wNloiIGZpbGw9IiMwODI3NUMiLz4KPC9zdmc+Cg==";
export { SvgDecoration1 as ReactComponent };